import a, { useState as j, useRef as le, useEffect as B } from "react";
import { useUniqueId as oe } from "../../hooks/useUniqueId.js";
import { Button as ae } from "./components/Button/Button.js";
import { Chips as re } from "./components/Chips/Chips.js";
import { Filter as ne } from "./components/Filter/Filter.js";
import { IconLeft as se } from "./components/IconLeft/IconLeft.js";
import { IconRight as ie } from "./components/IconRight/IconRight.js";
import { Options as ce } from "./components/Options/Options.js";
import { FormControlLabel as me, FormControlErrorORCaption as pe } from "../FormControl/FormControl.js";
import { handleOptionsNavigation as G } from "./utils/handleOptionsNavigation.js";
import { optionsNavigation as ue } from "./utils/optionsNavigation.js";
import { useClickOutside as de } from "./hooks/useClickOutside.js";
import { validateAccessibilityProps as fe, validateLabelAndIdProps as Oe } from "./utils/acessibilityErrors.js";
import { handleFilteredItems as _e } from "./utils/handleFilteredItems.js";
import { cls as _ } from "../../helpers/cls.js";
import { DropdownStates as r } from "./utils/states.js";
import { useVerification as be } from "./hooks/useVerification.js";
var he = Object.defineProperty,
  Ee = Object.defineProperties,
  we = Object.getOwnPropertyDescriptors,
  b = Object.getOwnPropertySymbols,
  k = Object.prototype.hasOwnProperty,
  V = Object.prototype.propertyIsEnumerable,
  A = (t, l, o) => l in t ? he(t, l, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : t[l] = o,
  C = (t, l) => {
    for (var o in l || (l = {})) k.call(l, o) && A(t, o, l[o]);
    if (b) for (var o of b(l)) V.call(l, o) && A(t, o, l[o]);
    return t;
  },
  ge = (t, l) => Ee(t, we(l)),
  xe = (t, l) => {
    var o = {};
    for (var n in t) k.call(t, n) && l.indexOf(n) < 0 && (o[n] = t[n]);
    if (t != null && b) for (var n of b(t)) l.indexOf(n) < 0 && V.call(t, n) && (o[n] = t[n]);
    return o;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const H = t => {
  var l = t,
    {
      items: o,
      onChange: n,
      placeholder: h,
      iconLeft: E,
      label: u,
      id: O,
      state: m,
      stateMessage: w,
      selectedItems: s = [],
      sizeMaxOverflow: K = "192px",
      sizeMaxChipContainer: g,
      caption: q,
      showList: M,
      clearInput: L = !1,
      autoFocus: S = !1,
      alwaysOpen: x = !1,
      noMatchMessage: U = "Nenhum resultado encontrado",
      "aria-label": d,
      "aria-labelledby": W,
      onTextChange: P = () => null
    } = l,
    J = xe(l, ["items", "onChange", "placeholder", "iconLeft", "label", "id", "state", "stateMessage", "selectedItems", "sizeMaxOverflow", "sizeMaxChipContainer", "caption", "showList", "clearInput", "autoFocus", "alwaysOpen", "noMatchMessage", "aria-label", "aria-labelledby", "onTextChange"]);
  const Q = M || x ? r.OPEN : r.CLOSED,
    X = [r.OPEN, r.EDITING],
    [p, c] = j(Q),
    f = le(null),
    i = X.includes(p);
  de({
    wrapperRef: f,
    isOpen: i,
    setDropdownState: c,
    showList: M
  });
  const [I, v] = j(""),
    D = a.useRef(null),
    N = a.useRef(null);
  B(() => {
    p === r.EDITING && setTimeout(() => {
      var e;
      return (e = D.current) == null ? void 0 : e.focus();
    }, 100), p === r.OPEN && S && c(r.EDITING);
  }, [p, S]), B(() => {
    L && v("");
  }, [L]);
  const Y = e => {
      s.includes(e) ? n(s.filter(y => y !== e)) : n([...s, e]), c(r.OPEN);
    },
    R = _e(o, I),
    T = oe("ds-multiselect-options"),
    Z = e => {
      n(s.filter(y => y !== e)), c(r.OPEN);
    },
    $ = () => {
      var e;
      p === r.OPEN ? (c(r.EDITING), v(""), (e = D.current) == null || e.focus()) : p === r.EDITING && !x ? c(r.CLOSED) : c(r.OPEN);
    },
    {
      isError: F,
      showDropdownList: z,
      messageHelpText: ee
    } = be({
      isOpen: i,
      state: m,
      items: o,
      filterTerm: I,
      filteredItems: R,
      noMatchMessage: U,
      stateMessage: w,
      caption: q
    });
  fe({
    ariaLabel: d,
    ariaLabelledBy: W,
    state: m,
    stateMessage: w,
    label: u
  }), Oe({
    label: u,
    id: O
  });
  const te = e => {
    v(e), P == null || P(e);
  };
  return a.createElement("div", C({
    className: "olx-multiselect",
    "data-ds-component": "DS-Multiselect"
  }, J), a.createElement(me, {
    size: "medium",
    marginBottom: "--spacing-1",
    htmlFor: O
  }, u), a.createElement("div", {
    ref: f,
    className: _({
      "olx-multiselect__content": !0,
      "olx-multiselect__content--error": F,
      "olx-multiselect__content--disabled": m === "disabled",
      "olx-multiselect__content--selected": s.length
    }),
    style: g ? {
      maxHeight: g
    } : {}
  }, a.createElement(se, {
    className: _({
      "olx-multiselect__icon-left": !0,
      "olx-multiselect__icon-left--open": s.length && i
    })
  }, E), a.createElement(ae, {
    className: _({
      "olx-multiselect__button": !0,
      "olx-multiselect__button--icon-left": E
    }),
    id: O,
    onClick: $,
    "aria-expanded": i,
    onKeyDown: e => G({
      e,
      wrapperRef: f,
      isOpen: i,
      setDropdownState: c
    }),
    disabled: m === "disabled",
    ref: N
  }, h && !(s != null && s.length) && !i && a.createElement(a.Fragment, null, h)), a.createElement(re, {
    selectedItems: s,
    items: o,
    onClick: e => Z(e),
    isOpen: i,
    className: _({
      "olx-multiselect__chips": !0,
      "olx-multiselect__chips--open": s.length && i,
      "olx-multiselect__chips--icon-left": E,
      "olx-multiselect__chips--size-max-container": g
    })
  }, m !== "error" && m !== "loading" && i && a.createElement(ne, ge(C(C({}, d && {
    "aria-label": d
  }), !d && {
    "aria-labelledby": O
  }), {
    isOpen: i,
    optionsID: T,
    ref: D,
    value: I,
    onChange: e => te(e.target.value),
    placeholder: s != null && s.length ? "" : h,
    onKeyDown: e => G({
      e,
      wrapperRef: f,
      isOpen: i,
      setDropdownState: c,
      buttonRef: N
    })
  }))), !x && a.createElement(ie, {
    state: m,
    isOpen: z,
    "aria-label": u != null ? u : d
  }), a.createElement(ce, {
    id: T,
    showDropdownList: z,
    filteredItems: R,
    selectedItems: s,
    handleCheckboxChange: Y,
    isOpen: i,
    sizeMaxOverflow: K,
    onKeyDown: e => ue({
      isOpen: i,
      wrapperRef: f,
      event: e,
      setDropdownState: c,
      buttonRef: N
    })
  })), a.createElement(pe, {
    hasError: F && !!w,
    marginTop: "--spacing-1"
  }, ee));
};
H.displayName = "Multiselect";
export { H as Multiselect };